import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import { AppUrl } from "../config";
const useStyles = makeStyles(() => ({
  backButton: {
    width: 160,
    height: 40,
    fontSize: "1rem",
    padding: 0,
    fontWeight: 400,
    margin: 0,
  },
  darkBackButton: {
    width: 240,
    height: 32,
  },
}));
interface Props {
  buttonLabel: string;
  app: string;
  backButtonURL: any;
  resetState: (app: string) => void;
  currentApp: string;
  disabled?: boolean;
  variant?: "dark";
}
function BackButton({
  buttonLabel,
  app,
  backButtonURL,
  resetState,
  currentApp,
  disabled,
  variant,
}: Props) {
  const classes = useStyles();
  const history = useHistory();

  function backButton() {
    if (backButtonURL && backButtonURL.slice(-1)[0]) {
      if (!backButtonURL.slice(-1)[0].split("?")[1]) {
        history.push(backButtonURL.pop());
        resetState(currentApp);
      } else {
        history.push(backButtonURL.pop());
      }
    } else {
      app === "API"
        ? (window.location.href = AppUrl(app))
        : history.push(AppUrl(app));
      resetState(currentApp);
    }
  }

  return (
    <Button
      className={clsx(
        variant === "dark" ? classes.darkBackButton : classes.backButton,
      )}
      id={buttonLabel.replace(/\s+/g, "-").toLowerCase()}
      onClick={backButton}
      disabled={disabled}
      variant="contained"
      color={variant === "dark" ? "primary" : "secondary"}
      disableElevation
    >
      {buttonLabel}
    </Button>
  );
}
export default BackButton;
